import { useEffect } from "react";
import { useSocialStore } from "../../../stores/social";
import { getHistoryMessages } from "../../../api/social";
import { showToastError } from "../../../services/toast";
import { useTranslation } from "react-i18next";

const FollowStatue = () => {
  const { t } = useTranslation();
  const { historyMessages, setHistoryMessages, updateSocial, idCustomer, setLastRefusedDate } =
    useSocialStore();

  useEffect(() => {
    getHistoryMessages(idCustomer)
      .then((res) => {
        setHistoryMessages(res.data);
        const lastRefusedDate = res.data.filter((message: any) => message.refused).map((message: any) => message.date);
        setLastRefusedDate(lastRefusedDate[0]);
      })
      .catch((err) => {
        showToastError(err.response.data.message);
      });
  }, [updateSocial]);

  return (
    <div className="w-full h-full">
      <div className="flex flex-col p-3 h-full">
        {/* En-tête Suivi - Compact */}
        <div className="flex items-center gap-2 mb-3">
          <div className="h-0.5 w-6 bg-linear-to-r from-red-400 to-red-500 rounded-full"></div>
          <h3 className="text-gray-700 font-semibold text-sm font-Nunito">{t("Suivi")}</h3>
        </div>
        
        {/* Zone de suivi scrollable - Compact */}
        <div className="flex-1 bg-gray-50 border border-gray-200 rounded-lg overflow-hidden">
          <div className="w-full h-full p-2 overflow-y-auto flex flex-col gap-2">
            {historyMessages?.length > 0 ? (
              historyMessages?.map((message) => (
                <div
                  key={message.id}
                  className={`${
                    message.type === "Company"
                      ? "bg-blue-50 border-blue-200"
                      : "bg-white border-gray-200"
                  } border rounded-lg p-2 shadow-sm hover:shadow-md transition-shadow duration-200`}
                >
                  <p className="text-[10px] font-medium text-gray-500 mb-1">
                    {message.date}
                  </p>
                  {message.validated && (
                    <p className="text-xs text-gray-700 leading-relaxed">
                      ✓ {t("Bulletins validés par")} <span className="font-medium">{message.user.email}</span>
                    </p>
                  )}
                  {message.refused && (
                    <p className="text-xs text-gray-700 leading-relaxed">
                      ✗ {t("Bulletins refusés par")} <span className="font-medium">{message.user.email}</span> <br />
                      <span className="font-medium">{message?.commentary}</span>
                    </p>
                  )}
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-400">
                <svg className="w-10 h-10 mb-2 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                <p className="text-xs font-medium">{t("Aucun suivi enregistré")}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowStatue;